import ImageOptimizer from '@/components/image-optimizer';
import { slugify } from '@/lib/utils';
import { BaseAcademyEntity } from '@/services/types/academy.type';
import Link from 'next/link';

const AcademyCard = (academy: BaseAcademyEntity) => {
  // const { data: keywordList } = useKeywordList();
  // const keywords = keywordList?.data || [];

  const slug = slugify(academy.title, academy.id);
  return (
    <Link
      href={`/academy/${slug}`}
      className="bg-bg-graylight desktop:p-6 desktop:gap-8 desktop:rounded-2xl border-stroke-graylight relative flex w-full gap-3 overflow-hidden rounded-xl border px-4 py-4 transition"
    >
      {/* 1. 이미지 */}
      <div className="desktop:h-[162px] desktop:w-[162px] desktop:rounded-lg relative h-[78px] w-[78px] shrink-0 overflow-hidden rounded-[6px]">
        <ImageOptimizer
          src={academy.photoPath ?? ''}
          alt={academy.title + ' 썸네일'}
          fill
          className="object-cover"
        />
      </div>

      {/* 2. 정보 섹션 */}
      <div className="flex flex-col">
        <h3 className="typo-22 text-level-1 desktop:typo-28 desktop:mt-[18px] desktop:mb-4 mb-3 line-clamp-1 font-extrabold">
          {academy.title}
        </h3>

        <div className="typo-16 text-level-3 desktop:typo-20 desktop:mb-2 mb-1 flex items-start font-bold">
          <ImageOptimizer
            src="/images/icons/icon_map_pin_black.svg"
            alt="위치"
            width={16}
            height={16}
            className="desktop:size-5 size-4 h-auto pt-[3px]"
          />
          <p className="ml-1 leading-snug">{academy.roadAddress}</p>
        </div>

        <div className="typo-16 text-level-3 desktop:typo-20 flex items-start font-bold">
          <ImageOptimizer
            src="/images/icons/icon_call_pin_black.svg"
            alt="위치"
            width={16}
            height={16}
            className="desktop:size-5 size-4 h-auto pt-[3px]"
          />
          <p className="ml-1 leading-snug">{academy.phone}</p>
        </div>
      </div>

      <div className="desktop:flex absolute right-[30px] bottom-[21px] hidden h-10 w-10 items-center justify-center rounded-full bg-white">
        <ImageOptimizer
          src="/images/icons/icon_plus_blue.svg"
          alt={academy.title + ' 바로가기'}
          width={20}
          height={20}
          className="size-5"
        />
      </div>
    </Link>
  );
};

export default AcademyCard;
